import { Box, Button, Container } from "@mui/material";

import { HeroText } from "components/shared/Typography";

export const Visit = () => (
  <Box
    component="section"
    pt={{ xs: 3, sm: 5, lg: 10 }}
    pb={{ xs: 4, sm: 7, lg: 12 }}
    className="default-bg"
  >
    <Container>
      <HeroText align="center" component="h2">
        Precision oncology starts with you. We&apos;re here to make it easy.
      </HeroText>
      <Box mt={4} display="flex" width={1} justifyContent="center">
        <Button size="large" onClick={() => window.open("/", "_blank")}>
          Visit Assay Marketplace
        </Button>
      </Box>
    </Container>
  </Box>
);
